module.exports = __webpack_public_path__ + "images/emoji/kissing_closed_eyes.969ce94888c5c09de055.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kissing_closed_eyes.png
// module id = f9/B
// module chunks = 13